<template>
	<div>
		<Video class='video'/>
	</div>
</template>

<script>
	import Video from '@/components/common/Video'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			Video,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){
				window.addEventListener('message', e => {
				    // e.data为父页面发送的数据
				    console.log(e.data)
				})
			},
		},
	}
</script>

<style lang='scss' scoped>
	.video {
		width: 100%;
		height:100vh;
	}
</style>